import { z } from 'zod';

export const SectionDtoScheme = z.object({
	id: z.number().describe('Уникальный идентификатор').nullable().optional(),
	title: z
		.string()
		.describe('Название')
		.transform(arg => (arg.length === 0 ? 'Без названия' : arg)),
	is_rc: z.boolean().describe('Это склад РЦ?').optional().default(false),
	is_all_allowed: z.boolean().describe('Доступен всем').optional().default(false),
	lat: z.string().describe('Широта').nullable().optional(),
	lon: z.string().describe('Долгота').nullable().optional(),
	department_id: z.string().optional().nullable().describe(''),
	organization_id: z.string().optional().nullable().describe(''),
});

export type SectionDto = z.infer<typeof SectionDtoScheme>;
